<template>
  <button
    class="btn btn--ok"
    type="button"
    :class="{ loading }"
    @click.stop="handleConfirm"
  >
      <keep-alive>
        <IconLoading
          v-show="loading"
          class="tw-mr-[6px]"
        />
      </keep-alive>
      <span><slot /></span>
  </button>
</template>

<script>
import IconLoading from 'fe-vui/IconLoading'

export default {
  name: 'ConfirmButton',
  components: {
    IconLoading
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn--ok {
  display: flex;
  height: 40px;
  box-sizing: border-box;
  flex: 1;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffca27;
  border-radius: 20px;
  background: #ffca27;
  color: #000;
  font-size: 14px;
  line-height: 1.2;
  text-align: center;

  &:hover {
    background: #ffefbf;
  }

  &:active:not(.loading) {
    border-color: #b28d1b;
    background: #b28d1b;
  }

  &.loading {
    border: 1px solid #ffefbf !important;
    background: #ffefbf !important;
    cursor: not-allowed;
  }
}
</style>